import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/Button";
import { Spinner } from "../ui/Spinner";
import "./NavigationButtons.css";

interface NavigationButtonsProps {
  onNext: () => void;
  onBack: () => void;
  canGoNext: boolean;
  canGoBack: boolean;
  isLastStep?: boolean;
  isLoading?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onNext,
  onBack,
  canGoNext,
  canGoBack,
  isLastStep = false,
  isLoading = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="navigation-buttons">
      {canGoBack && (
        <Button
          type="button"
          onClick={onBack}
          variant="outlined"
          color="neutral"
          disabled={isLoading}
          aria-label={t("navigation.back")}
        >
          {t("navigation.back")}
        </Button>
      )}
      <Button
        type="button"
        onClick={onNext}
        variant="filled"
        color="primary"
        disabled={!canGoNext || isLoading}
        aria-label={isLastStep ? t("navigation.submit") : t("navigation.next")}
      >
        {isLoading ? (
          <Spinner 
            unstyled 
            className="w-5 h-5 rounded-full border-[3px] border-white border-r-transparent animate-spin" 
          />
        ) : isLastStep ? (
          t("navigation.submit")
        ) : (
          t("navigation.next")
        )}
      </Button>
    </div>
  );
};

